module.exports = __webpack_public_path__ + "img/collection-weddingRingsSoleil@2x.d50bf81.webp";